const ApiConstant = {
    baseApiUser: "https://opc-backend-mzgw.onrender.com/api/users",
    baseApiProduct: "https://opc-backend-mzgw.onrender.com/api/products",
    baseApiAnnouncement: "https://opc-backend-mzgw.onrender.com/api/announcements",
}

export default ApiConstant;